// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import scrollTo from "./components/scrollTo";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import coverTable from "./components/coverTable";
import loadGame from "./components/loadGame";
import editorContent from "./components/content";

document.addEventListener('DOMContentLoaded', function () {

    lazyLoad();

    let myLazyLoad = new LazyLoad();

    let btn = document.querySelector('#toTop');
    if (btn) {
        window.addEventListener('scroll', function () {
            // show if > 599px
            if (pageYOffset > 100) {
                btn.classList.add('show');
                // remove
            } else {
                btn.classList.remove('show');
            }
        });

        // to top on click
        btn.onclick = function (click) {
            click.preventDefault();
            scrollTo(0, 400);
        }
    }

    const main = document.querySelector("main");
    const firstSection = main.querySelector("section");
    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");

    if (firstSection && breadcrumbs) {
        if (firstSection.classList.contains("banner")) {
            breadcrumbs.style.position = "absolute";
        } else {
            breadcrumbs.style.position = "static";
        }
    }

    MobileBurgerMenu();

    editorContent();

    // adaptive table class
    coverTable();

    // iframe on click
    loadGame();

});

// import custom scripts
import './custom-app'



